exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(true);
// imports


// module
exports.push([module.id, ".big-icon{font-size:21px}", "", {"version":3,"sources":["/home/circleci/phdva/ui/src/components/Header/HeaderDropdownAccnt.vue"],"names":[],"mappings":"AACA,UACE,cAAgB,CACjB","file":"HeaderDropdownAccnt.vue","sourcesContent":["\n.big-icon {\n  font-size: 21px;\n}\n"],"sourceRoot":""}]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"minimize":true,"sourceMap":true,"alias":{"../img":"../static/img"}}!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-72458775","scoped":false,"hasInlineConfig":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/Header/HeaderDropdownAccnt.vue
// module id = 1371
// module chunks = 0